module.exports = __webpack_public_path__ + "img/蝴蝶阀.sldprt.f08b95a0.jpg";